module.exports = __webpack_public_path__ + "img/anesthesiology-banner.02301e82.png";